import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProjectSheet } from 'app/modules/projects/details/sheets/sheets.types';
import { ProjectSheetsService } from 'app/modules/projects/details/sheets/sheets.service';
import { ProjectSheetsComponent } from 'app/modules/projects/details/sheets/sheets.component';

@Component({
  selector: 'project-sheets-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectSheetsDetailsComponent extends OnDestroyMixin implements OnInit {
  projectSheets: ProjectSheet[];
  projectSheet: ProjectSheet;
  isLoading: boolean;
  pagination: any;
  drawerMode: 'over' | 'side';
  drawerOpened: boolean;

  @ViewChild('noteList') noteList: ElementRef;
  @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;

  constructor(
    public projectSheetsComponent: ProjectSheetsComponent,
    private readonly _projectSheetsService: ProjectSheetsService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
    this.isLoading = false;
  }

  ngOnInit(): void {
    this.projectSheetsComponent.drawer?.close();
    // Notes
    this._projectSheetsService.projectSheets$
      .pipe(untilComponentDestroyed(this))
      .subscribe((projectSheets: ProjectSheet[]) => {
        this.projectSheets = projectSheets;
        this._changeDetectorRef.markForCheck();
      });

    // Selected mail
    this._projectSheetsService.projectSheet$
      .pipe(untilComponentDestroyed(this))
      .subscribe((projectSheet: ProjectSheet) => {
        if (projectSheet) {
          this.projectSheet = projectSheet;
        }

        this._changeDetectorRef.markForCheck();
      });
  }
}
